import { pipe } from 'ramda';
import { createSelector } from 'reselect';

import { IRootState } from '../../../../store/root.types';
import { getIsDonation } from '../settings/settings.selectors';

const getTagsState = (state: IRootState) => state.marketplace.tags;

const getSelectedTags = pipe(getTagsState, state => state.selectedTags);

export const getShouldSelectTags = createSelector(
  getSelectedTags,
  getIsDonation,
  (selectedTags, isDonation) => !isDonation && selectedTags.isLoaded && selectedTags.data === null,
);

export const getAvailableTags = pipe(getTagsState, state => state.availableTags);
export const getIsAvailableTagsLoading = pipe(getTagsState, state => state.isLoading);

export const getIsSaveInProgress = pipe(getTagsState, state => state.isSaveInProgress);
